import axios from  'axios'
import store from '@/store'

const api = {

  async post ( path, data ) {
    try {
      return await axios.post(
        this.adminApi(path), data, this.publicOptions())
        .then( response => response )
    } catch (e) {
      console.log(e)
      return e.status
    }
  },

  async get (path, adminHeaders) {
    try {
      return await axios.get( 
          this.adminApi(path),
          this.publicOptions(adminHeaders)
        )
        .then( (response) => {
          return response 
        })
    } catch {
      return false
    }
  },

  async postAdmin ( path, data, adminHeaders ) {
    try {
      return await axios.post( 
        this.adminApi(path), 
        data, 
        this.adminOptions(adminHeaders)
        )
        .then( response => response )
    } catch (e) {
      return e
    }
  },

  async putAdmin ( path, data, adminHeaders ) {
    try {
      return await axios.put( 
        this.adminApi(path), 
        data, 
        this.adminOptions(adminHeaders)
        )
        .then( response => response )
    } catch (e) {
      return e
    }
  },

  async deleteAdminById ( path, adminHeaders ) {
    try {
      return await axios.delete( 
        this.adminApi(path), 
        this.adminOptions(adminHeaders)
        )
        .then( response => response )
    } catch (e) {
      return e
    }
  },

  async getAdmin (path, adminHeaders) {
    try {
      return await axios.get( 
        this.adminApi(path), 
        this.adminOptions(adminHeaders)
        )
        .then( response => response )
    } catch (e) {
      return e
    }
  },

  adminApi ( path ) {
    let baseurl =  process.env.VUE_APP_API_ROOT
    if ( !baseurl.endsWith('/') ) {
      baseurl += '/'
    }
    //baseurl += 'admin/'
    let p = path
    if ( p.startsWith('/') ) {
      p = path.slice(1)
    }
    return `${baseurl}${p}`
  },

  adminOptions ( additionalHeaders ) {
    // Access token is memory-only now (Vuex), never localStorage. It is
    // absent until the silent refresh on boot resolves, so only send the
    // Authorization header when we actually have one.
    const token = store.getters['stateUser/accessToken']
    const defaultHeaders = token
      ? { Authorization: `Bearer ${token}` }
      : {}
    return {
      withCredentials: true, // required for the httpOnly refresh cookie to flow
      headers: Object.assign(
        {},
        defaultHeaders,
        ( additionalHeaders ? additionalHeaders.headers: {}
      ))
    }
  },

  publicApi ( path ) {
    let baseurl =  process.env.VUE_APP_API_ROOT
    if ( !baseurl.endsWith('/') ) {
      baseurl += '/'
    }
    //baseurl += 'admin/'
    let p = path
    if ( p.startsWith('/') ) {
      p = path.slice(1)
    }
    return `${baseurl}${p}`
  },

  publicOptions ( additionalHeaders ) {
    const token = localStorage.getItem('uid')

    if(token) {
      const defaultHeaders = {
        headers: {
          ukey: `${token}`
        }
      }
      return {
        withCredentials: true, // required so signin/refresh can set/send the cookie
        headers: Object.assign(
          {},
          defaultHeaders.headers,
          ( additionalHeaders ? additionalHeaders.headers: {}
        ))
      }
    } else {
      return {
        withCredentials: true,
        headers: Object.assign(
          {},
          {},
          ( additionalHeaders ? additionalHeaders.headers: {}
        ))
      }
    }
  }
  
}

export default api